// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bwgY8","btnWrapper":"styles_btnWrapper__F2v0N","contentWrapper":"styles_contentWrapper__Rwa4Q","inputListWrapper":"styles_inputListWrapper__SiP0o"};